import { createSlice } from "@reduxjs/toolkit";
import {
  getCommAuditTrailsAction,
  searchCasesAction,
  createCommAuditTrailAction,
} from "../../actions/CommAuditTrails/commAuditTrailsActions";

const initialState = {
  commAuditTrails: [],
  cases: [],
  loading: false,
  error: null,
  isCreated: false,
};

const commAuditTrailsSlice = createSlice({
  name: "commAuditTrails",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.isCreated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommAuditTrailsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommAuditTrailsAction.fulfilled, (state, action) => {
        state.loading = false;
        const raw = action.payload?.data || action.payload;
        state.commAuditTrails = Array.isArray(raw) ? raw : Object.values(raw);
      })
      .addCase(getCommAuditTrailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(searchCasesAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchCasesAction.fulfilled, (state, action) => {
        state.loading = false;
        state.cases = action.payload?.data || action.payload;
      })
      .addCase(searchCasesAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCommAuditTrailAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isCreated = false;
      })
      .addCase(createCommAuditTrailAction.fulfilled, (state, action) => {
        state.loading = false;
        state.isCreated = true;
        const created = action.payload?.data || action.payload;
        if (created) {
          state.commAuditTrails.push(created);
        }
      })
      .addCase(createCommAuditTrailAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isCreated = false;
      });
  },
});

export const { resetState } = commAuditTrailsSlice.actions;
export default commAuditTrailsSlice.reducer;
